class ParallaxPreview extends HTMLElement {
  constructor() {
    super();
    this.section = this.dataset.section;
    this.video = this.querySelector('video') || null;
    this.designMode = this.dataset.designMode === 'true' ? true : false;
  }

  connectedCallback() {
    this.loadAndPauseVideo();
    this.setupObserver();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  setupObserver() {
    const _this = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          _this.scrubVideo();
        }
      });
    });

    let section = this;

    this.observer.observe(section);
  }

  loadAndPauseVideo() {
    for (var source in this.video.children) {
      var videoSource = this.video.children[source];
      if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
        videoSource.src = videoSource.dataset.src;
      }
    }
    this.video.load();
    this.video.pause();
  }

  scrubVideo() {
    var _this = this;
    const distanceFromTop = this.getBoundingClientRect().top + window.scrollY;
    const height = this.offsetHeight;
    window.addEventListener(
      'scroll',
      debounce(function (e) {
        const offsetTop = distanceFromTop - height;
        const offsetBottom = distanceFromTop + height;
        if (window.scrollY >= offsetTop && window.scrollY <= offsetBottom) {
          const percentageScrolled = parseFloat((window.scrollY + height - distanceFromTop) / height / 2).toFixed(3);
          if (_this.video.duration > 0) {
            _this.video.currentTime = parseFloat(_this.video.duration * percentageScrolled);
          }
        }
      }),
      100
    );
  }
}

customElements.define('parallax-preview', ParallaxPreview);

class ProductTourModal extends ModalDialog {
  constructor() {
    super();
    this.youtube = this.querySelector('lite-youtube');
  }

  connectedCallback() {
    const tag = document.createElement('script');
    const _this = this;
    tag.id = 'iframe-demo';
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubePlayerAPIReady = function () {
      _this.youtube.addEventListener('liteYoutubeIframeLoaded', _this.handleLoaded.bind(_this));
    };
  }

  handleLoaded(e) {
    this.video = e.detail.videoId;
    this.player = new YT.Player(document.querySelector('#product-tour').shadowRoot.querySelector('iframe'), {
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange,
      },
    });
  }

  onReady(e) {
    return e.data;
  }

  onPlayerStateChange(e) {
    return e.data;
  }

  show(opener) {
    super.show(opener);
    setTimeout(() => {
      // console.log('show', this.player, this.youtube);
      if (!this.player) {
        this.youtube.click();
      } else {
        this.player.playVideo();
      }
    }, 300);
  }

  hide() {
    this.player.stopVideo();
    super.hide();
  }
}

customElements.define('product-tour-modal-dialog', ProductTourModal);
